export default "__VITE_ASSET__CjrrBlFt__"